'use client';

import { MemberWithUser } from '@zond/api-interfaces';
import { createContext, ReactNode, useContext, useState } from 'react';

type DialogType = 'add' | 'edit' | 'delete' | 'invite' | null;

interface UsersContextType {
  open: DialogType;
  setOpen: (type: DialogType) => void;
  currentRow: MemberWithUser | null;
  setCurrentRow: (member: MemberWithUser | null) => void;
}

const UsersContext = createContext<UsersContextType | undefined>(undefined);

export function UsersProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState<DialogType>(null);
  const [currentRow, setCurrentRow] = useState<MemberWithUser | null>(null);

  return (
    <UsersContext.Provider
      value={{
        open,
        setOpen,
        currentRow,
        setCurrentRow,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
}

export function useUsers() {
  const context = useContext(UsersContext);
  if (context === undefined) {
    throw new Error('useUsers must be used within a UsersProvider');
  }
  return context;
}
